export const SaasRoleName = {
    Unspecified: 'unspecified',
    User: 'user',
    Writer: 'writer',
    Admin: 'admin',
    Publisher: 'publisher',
    AccessAdmin: 'accessAdmin',
};
export const SaasRoleId = {
    Unspecified: 0,
    User: 1,
    Writer: 2,
    Admin: 3,
    Publisher: 4,
    AccessAdmin: 5,
};
//# sourceMappingURL=SaasRole.js.map